import {ApplicationLayout, ApplicationLayoutBodyNavigation} from "@rio-cloud/rio-uikit";
import {NavLink, Outlet} from "react-router-dom";
import SubNavigation from "@rio-cloud/rio-uikit/SubNavigation";
import {ErrorBoundary} from "./ErrorBoundary.tsx";
import {GlobalConfirmDialogRenderer} from "./Dialog/GlobalConfirmDialogRenderer.tsx";


export const Layout = () => {
    return <ApplicationLayout>
        <ApplicationLayout.Body innerClassName={(window.self !== window.top) ? "padding-0" : ""}>
            <ApplicationLayoutBodyNavigation>
                <SubNavigation
                    navItems={[
                        // {
                        //     key: '/config',
                        //     route: <NavLink to={"/config"}>Configuration</NavLink>,
                        // },
                        {
                            key: "/shift",
                            route: <NavLink to={"/shift"}>Shift</NavLink>
                        },
                        {
                            key: '/import',
                            route: <NavLink to={"/import"}>Import</NavLink>,
                        },
                        {
                            key: "/about",
                            route: <NavLink to={"/about"}>About</NavLink>
                        }
                    ]}/>
            </ApplicationLayoutBodyNavigation>
            <ErrorBoundary>
                <Outlet/>
            </ErrorBoundary>
            <ErrorBoundary>
                <GlobalConfirmDialogRenderer/>
            </ErrorBoundary>
        </ApplicationLayout.Body>
    </ApplicationLayout>
}